import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuantityChangedInQuickOrderParameters extends TrackEventBaseParameters {}

const trackQuantityChangedInQuickOrder = (
    parameters: TrackQuantityChangedInQuickOrderParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "quantity_changed_in_quick_order", ...parameters }, options);
};

export default trackQuantityChangedInQuickOrder;
